import React from "react";
import { useQuery } from "@tanstack/react-query";
import * as Function from "../utils/Functions";
import authApi from "../utils/api/authApi";
import * as ApiPaths from "../enums/ApiPaths";
import { HttpStatusCode } from "axios";
import useUser from "../hooks/useUser";
import { useFetch } from "../hooks/Fetching";

export const NotificationsContext = React.createContext();
export const pendingNotificationKey = "pendingAppointmentsCount";
export default function NotificationsProvider({ children }) {
  const { currentClinic, roles, profile, isLoading } = useUser();
  const [newInbox, setNewInbox] = React.useState(false);
  const [convoId, setConvoId] = React.useState(null);
  const clinicId = currentClinic?.id;
  const key = roles.adminOrEmployee
    ? "convo_count" + clinicId
    : "convo_count" + profile.id;

  const convosCount = useFetch(
    ApiPaths.UNRED_CONVOS_COUNT,
    null,
    key,
    !roles.master && !isLoading
  );

  function handleSetConvoToUpdate(id) {
    if (isNaN(Number(id))) {
      setConvoId(null);
    } else {
      setConvoId(Number(id));
    }
  }

  const newInboxToggle = () => {
    setNewInbox((prev) => !prev);
  };

  const fetchPendingCount = async () => {
    if (!roles.adminOrEmployee || !clinicId) return 0;

    const header = await Function.getBearerToken();
    const res = await authApi.get(
      `${ApiPaths.PENDING_APPOINTMENTS_COUNT}/${clinicId}`,
      {
        headers: header,
      }
    );

    if (res.status === HttpStatusCode.Ok) {
      return res.data;
    }
    return 0;
  };

  const { data: notifications = 0, refetch } = useQuery({
    queryKey: [pendingNotificationKey + clinicId],
    queryFn: fetchPendingCount,
    enabled: !!clinicId && !!roles.adminOrEmployee,
  });

  const values = {
    newInboxToggle,
    notifications,
    newInbox: convosCount.data,
    convoId,
    handleSetConvoToUpdate,
    refetchNotifications: refetch,
  };

  return (
    <NotificationsContext.Provider value={values}>
      {children}
    </NotificationsContext.Provider>
  );
}
